import { useState } from "react";
import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table/interface";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, defaultMdCmParam } from "@/utils/constants";
import { IFiltrationSeachFields, filtrationService, IFiltrationDetails } from "./filtrationService";
import { transPgToPagination } from "@/model/globalModel";
import { ISearchPage } from "@/types/AppTypes";
import useStorageState from "@/hooks/useStorageState";


export const useFiltrationModel = createModel(function () {
    //列表数据源
    const [dataSource, setDataSource] = useState<IFiltrationDetails[]>([]);
    //查询条件
    const [searchParam, setSearchParam] = useState<IFiltrationSeachFields>({});
    //时间区间
    const [searchParamTime, setSearchParamTime] = useState<IFiltrationSeachFields>({});
    //分页参数
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    const [loading, setLoading] = useState<boolean>(false);
    const [showOne, setShowOne] = useState<boolean>(true);
    //行选id
    const [selectedRowKeys, setSelectedRowKeys] = useState<IFiltrationDetails[]>([]);
    //列表查询
    const loadData = async (page: ISearchPage = initPgCfg, searchValue: IFiltrationSeachFields = searchParam, timeValue = searchParamTime) => {
        setLoading(true)
        const searchParams = {
            ...searchValue,
            ...timeValue,
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.current || page?.pageNum) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        try {
            let { retData } = await filtrationService.page(searchParams);
            const { records, ...pg } = retData;
            setPgCfg(transPgToPagination(pg));
            setLoading(false);
            setDataSource(records);
            return records;
        } catch (err) { setLoading(false) }
    }


    /**
     * 过滤库详情
     */

    const [filtrationOne, setFiltrationOne] = useStorageState<IFiltrationDetails[]>("filtration.detail", []);

    return {
        /***field***/
        searchParam,
        dataSource,
        pgCfg, loading,
        searchParamTime, setSearchParamTime,
        /***method***/
        setDataSource,
        setSearchParam,
        loadData,
        filtrationOne, setFiltrationOne,
        selectedRowKeys, setSelectedRowKeys,
        showOne, setShowOne
    }
});